export enum ETrackerPaymentMessage {
  BUTTON_CLICK = 'Web client click at submit button',
  TY_PAGE = 'Web client show TY page',
}
